import { useConfig } from '@hooks/use-config/index';

const WP_TICKET_CONFIG_URL = "wp-json/smtickets/v1/values"

export const useTicketsConfig = () => {
    return useConfig(WP_TICKET_CONFIG_URL);
}